import { render, staticRenderFns } from "./SwitcherSelector.vue?vue&type=template&id=fe3e1780&"
import script from "./SwitcherSelector.vue?vue&type=script&lang=js&"
export * from "./SwitcherSelector.vue?vue&type=script&lang=js&"
import style0 from "./SwitcherSelector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports